// https://vuex.vuejs.org/en/state.html

export default {
  user: getClaim(),
  company: null,
  site: null,
  sites: []
}

function getClaim () {
  try {
    return JSON.parse(localStorage.getItem('claim'))
  } catch (e) {
    return null
  }
}
